/**
 * @voltxampere/ui — Headphone amp generic (Sprint 45-2, placeholder)
 *
 * PLACEHOLDER. Yüksek empedans çıkış için generic kulaklık
 * amplifikatörü — şu anki stamp tek `opamp` üzerinden. Gerçek
 * Class-A push-pull output stage + zero-feedback transformer
 * coupling (audiophile DIY) Sprint 50+'da.
 *
 * Reference: Generic op-amp based headphone amp (e.g. CMoy circuit
 * with OPA2134 + buffer transistor). V_supply ±9 to ±18 V (battery
 * dual rail), gain 5-11 (line level → headphone drive), THD
 * <0.001% audiophile target, output empedans <0.5 Ω. DIY hi-fi
 * portable headphone amp + studio reference monitor amp.
 *
 *   Default mapping → opamp schemaType:
 *     openLoopGain = 1e5       (audiophile op-amp baseline)
 *     poleFrequency = 30       (3 MHz GBW / 1e5)
 *     saturationVoltage = 14   (V_supply ±18V close-to-rail)
 *
 * Engine zero-diff invariant honored — canonical `opamp` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const audioHeadphoneAmp = {
    id: "headphone-amp",
    nameTr: "Kulaklık Amfi (CMoy generic, placeholder)",
    nameEn: "Headphone Amp (CMoy generic, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "HP-AMP",
    schemaType: "opamp",
    defaultParams: { openLoopGain: 1e5, poleFrequency: 30, saturationVoltage: 14 },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=audio-headphone-amp.js.map